import { type IkeClientService, Services } from './index';

export class DownloadService implements IkeClientService {
	__priority = 100;

	public lastDownloadFilename: string | null = null;

	download(url: string, filename?: string) {
		return setTimeout(() => {
			const link = Services.Window.document.createElement('a');
			link.download = filename == null ? '' : filename;
			link.href = url;
			Services.Window.document.body.appendChild(link);
			link.click();
			link.remove();
			this.lastDownloadFilename = filename ?? null;
		}, 250);
	}
}
